import React from 'react';
import { sanitize } from 'utilities/sanitizer';

const html =
  '<div class="flex flex-col font-medium text-med-gray-3 gap-5"><div class="flex flex-col gap-2.5"><div class="text-neutral-800"><p class="font-bold">Effective Date: June 10, 2025</p><p class="font-bold">Last Revised: May 2025</p></div></div><div class="flex flex-col gap-2.5 text-med-gray-3"><h2 class="font-bold text-neutral-800 mb-2.5 text-h4">Cancellation</h2><p>At Decode.Me ("we," or "us"), we understand that unforeseen circumstances may require you to change your scheduled appointments on the Decode.Me platform. Our appointment calendar is designed to help you choose a time and day that aligns with both your schedule and that of your preferred care provider. To ensure efficient scheduling and availability for all our users, we have established the following cancellation policy, with reminders in days, hours, and even minutes before the appointment to help you remember your appointment and “arrive” on time.</p><p>You will receive general notifications:</p><ul class="list-none flex flex-col italic ml-2.5"><li>- appointment with [your full name] starting in 1 day</li><li>- appointment with [your full name] starting in 1 hour</li><li>- appointment with [your full name] starting in 5 minutes</li></ul><p>You will also see a reminder in the Decode.Me header 30 minutes before your appointment starts</p></div><div class="flex flex-col gap-2.5 text-med-gray-3"><h2 class="font-bold text-neutral-800 mb-2.5 text-h4">Official HHS Resources (Definitive Authority)</h2><p>If you cancel your appointment less than 24 hours before the scheduled time and date, your appointment becomes non-refundable. Specifically, you will be listed as a “No Show” and charged the full amount of the appointment. Please also note that booking an appointment requires the use of credit services (e.g. Stripe), and <span class="underline">any cancellation</span> at any time will result in fees of 2.9% of the appointment cost of the appointment+plus $0.30. If your provider cancels the appointment and cannot reschedule, the provider will be responsible for this fee.</p><p>After three consecutive No-Shows to your appointment, Decode.Me reserves the right to suspend or terminate its relationship with you.</p></div><div class="flex flex-col gap-2.5 text-med-gray-3"><h2 class="font-bold text-neutral-800 mb-2.5 text-h4">Late Arrival</h2><p>Please make every effort to be on time for your appointment. If you are:</p><ul class="list-none flex flex-col italic ml-2.5"><li>&gt; 3 minutes late for a 12-minute appointment, your provider will have the right to cancel the appointment, and you will still be charged the full amount.</li><li>&gt; 10 minutes late to a 30-minute or 60-minute appointment, your provider will have the right to cancel the appointment, and you will still be charged the full amount,</li></ul><p>If your provider is late by these times, the appointment will be pro-rated by the time available.</p><p>For example, in a 15-minute appointment, 12 minutes are with the provider and 3 minutes are for their follow-up notes. If your provider is exactly 3 minutes late your charge for the appointment will be 9/12 or 75% of the cost.</p></div></div>';

const AppointmentCancellation = () => {
  return (
    <div
      className="flex flex-col gap-5"
      dangerouslySetInnerHTML={{ __html: sanitize(html) }}
    />

    // <div className="flex flex-col font-medium text-med-gray-3 gap-5">
    //   <div className="flex flex-col gap-2.5">
    //     <div className="text-neutral-800">
    //       <p className="font-bold">Effective Date: June 10, 2025</p>
    //       <p className="font-bold">Last Revised: May 2025</p>
    //     </div>
    //   </div>
    //   <div className="flex flex-col gap-2.5 text-med-gray-3">
    //     <h2 className="font-bold text-neutral-800 mb-2.5 text-h4">
    //       Cancellation
    //     </h2>
    //     <p>
    //       At Decode.Me ("we," or "us"), we understand that unforeseen
    //       circumstances may require you to change your scheduled appointments on
    //       the Decode.Me platform. Our appointment calendar is designed to help
    //       you choose a time and day that aligns with both your schedule and that
    //       of your preferred care provider. To ensure efficient scheduling and
    //       availability for all our users, we have established the following
    //       cancellation policy, with reminders in days, hours, and even minutes
    //       before the appointment to help you remember your appointment and
    //       “arrive” on time.
    //     </p>
    //     <p>You will receive general notifications:</p>
    //     <ul className="list-none flex flex-col italic ml-2.5">
    //       <li>- appointment with [your full name] starting in 1 day</li>
    //       <li>- appointment with [your full name] starting in 1 hour</li>
    //       <li>- appointment with [your full name] starting in 5 minutes</li>
    //     </ul>
    //     <p>
    //       You will also see a reminder in the Decode.Me header 30 minutes before
    //       your appointment starts
    //     </p>
    //   </div>
    //   <div className="flex flex-col gap-2.5 text-med-gray-3">
    //     <h2 className="font-bold text-neutral-800 mb-2.5 text-h4">
    //       Official HHS Resources (Definitive Authority)
    //     </h2>
    //     <p>
    //       If you cancel your appointment less than 24 hours before the scheduled
    //       time and date, your appointment becomes non-refundable. Specifically,
    //       you will be listed as a “No Show” and charged the full amount of the
    //       appointment. Please also note that booking an appointment requires the
    //       use of credit services (e.g. Stripe), and
    //       <span className="underline">any cancellation</span> at any time will
    //       result in fees of 2.9% of the appointment cost of the appointment+plus
    //       $0.30. If your provider cancels the appointment and cannot reschedule,
    //       the provider will be responsible for this fee.
    //     </p>
    //     <p>
    //       After three consecutive No-Shows to your appointment, Decode.Me
    //       reserves the right to suspend or terminate its relationship with you.
    //     </p>
    //   </div>
    //   <div className="flex flex-col gap-2.5 text-med-gray-3">
    //     <h2 className="font-bold text-neutral-800 mb-2.5 text-h4">
    //       Late Arrival
    //     </h2>
    //     <p>
    //       Please make every effort to be on time for your appointment. If you
    //       are:
    //     </p>
    //     <ul className="list-none flex flex-col italic ml-2.5">
    //       <li>
    //         {'>'} 3 minutes late for a 12-minute appointment, your provider will
    //         have the right to cancel the appointment, and you will still be
    //         charged the full amount.
    //       </li>
    //       <li>
    //         {'>'} 10 minutes late to a 30-minute or 60-minute appointment, your
    //         provider will have the right to cancel the appointment, and you will
    //         still be charged the full amount,
    //       </li>
    //     </ul>
    //     <p>
    //       If your provider is late by these times, the appointment will be
    //       pro-rated by the time available.
    //     </p>
    //     <p>
    //       For example, in a 15-minute appointment, 12 minutes are with the
    //       provider and 3 minutes are for their follow-up notes. If your provider
    //       is exactly 3 minutes late your charge for the appointment will be 9/12
    //       or 75% of the cost.
    //     </p>
    //   </div>
    // </div>
  );
};

export default AppointmentCancellation;
